// extracted by mini-css-extract-plugin
export var deliveryRow = "_si-a";
export var fixedHeight = "_si-4";
export var freightLogo = "_si-9";
export var fullWidth = "_si-3";
export var priceColumn = "_si-5";
export var radioSelected = "_si-7";
export var radioUnselected = "_si-6";
export var selectedOption = "_si-2";
export var selectedOptionContainer = "_si-1";
export var selection = "_si-0";
export var tallSkeletonText = "_si-8";